module.exports = __webpack_public_path__ + "img/shelf-bottom.dab9fc38.png";